export default __webpack_public_path__ + "img/Gill.be9f9e55.png";